module.exports = __webpack_public_path__ + "img/16.e44a981f.png";